import { template as template_7cd8f865af84439f865b030205339d0e } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/icon';
export default RouteTemplate(template_7cd8f865af84439f865b030205339d0e(`
  <@model.Component />
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
